import React from "react";

export type UseMenuAnchorStateProps = {
    onOpen?: () => void;
    onClose?: () => void;
};

const useMenuAnchorState = (props?: UseMenuAnchorStateProps) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const onOpenMenu = React.useCallback(
        (event: React.MouseEvent<HTMLElement>) => {
            setAnchorEl(event.currentTarget);
            props?.onOpen?.();
        },
        [props]
    );
    const onCloseMenu = React.useCallback(() => {
        setAnchorEl(null);
        props?.onClose?.();
    }, [props]);

    return {
        open: Boolean(anchorEl),
        onOpenMenu,
        onCloseMenu,
        anchorEl,
    };
};

export default useMenuAnchorState;
